/**
 * Datos de talleres del Colegio Bertolt Brecht
 */

export const WORKSHOPS_DATA = [
    {
        id: 1,
        title: 'Taller de Música',
        icon: '🎵',
        description: 'Cultiva el amor por la música, desde tocar instrumentos hasta explorar la teoría musical.',
        fullDescription: `El Taller de Música del Colegio Bertolt Brecht ofrece una experiencia completa de aprendizaje musical para estudiantes de todos los niveles.

Nuestro programa incluye:
- Aprendizaje de instrumentos (guitarra, piano, flauta, percusión)
- Teoría musical básica e intermedia
- Solfeo y lectura de partituras
- Ensambles y práctica grupal
- Presentaciones y recitales semestrales

Los estudiantes desarrollarán habilidades musicales mientras fortalecen su disciplina, concentración y expresión artística.`,
        benefits: [
            'Desarrollo del oído musical',
            'Aprendizaje de instrumentos',
            'Teoría musical básica',
            'Presentaciones y recitales'
        ],
        schedule: 'Martes y Jueves, 3:30 PM - 5:00 PM',
        instructor: 'Prof. María González',
        level: 'Todos los niveles',
        image: null,
        imageAlt: 'Taller de Música',
        color: 'primary'
    },
    {
        id: 2,
        title: 'Taller de Deporte',
        icon: '⚽',
        description: '¡Prepárate para la acción! Mejora habilidades físicas, coordinación, trabajo en equipo y camaradería.',
        fullDescription: `El Taller de Deporte promueve el desarrollo físico integral y los valores deportivos en nuestros estudiantes.

Actividades incluidas:
- Fútbol y básquetbol
- Atletismo y gimnasia
- Juegos recreativos y competitivos
- Preparación física general
- Participación en torneos interescolares

Fomentamos el trabajo en equipo, la disciplina deportiva y el espíritu competitivo saludable.`,
        benefits: [
            'Desarrollo físico y motor',
            'Trabajo en equipo',
            'Disciplina deportiva',
            'Competencias y torneos'
        ],
        schedule: 'Lunes, Miércoles y Viernes, 3:30 PM - 5:00 PM',
        instructor: 'Prof. Carlos Ramírez',
        level: 'Todos los niveles',
        image: null,
        imageAlt: 'Taller de Deporte',
        color: 'secondary'
    },
    {
        id: 3,
        title: 'Club de Inglés',
        icon: '🌍',
        description: 'Desarrolla habilidades lingüísticas y comunicativas a través de juegos, canciones y actividades interactivas.',
        fullDescription: `El Club de Inglés ofrece un ambiente dinámico y divertido para el aprendizaje del idioma inglés.

Metodología:
- Conversación práctica y fluida
- Juegos y actividades lúdicas
- Canciones y material audiovisual
- Proyectos y presentaciones
- Preparación para certificaciones internacionales (Cambridge, TOEFL)

Nuestro enfoque comunicativo permite a los estudiantes desarrollar confianza al hablar inglés en situaciones reales.`,
        benefits: [
            'Conversación fluida',
            'Gramática práctica',
            'Vocabulario amplio',
            'Certificaciones internacionales'
        ],
        schedule: 'Martes y Jueves, 4:00 PM - 5:30 PM',
        instructor: 'Prof. Jennifer Smith',
        level: 'Básico a Avanzado',
        image: null,
        imageAlt: 'Club de Inglés',
        color: 'primary'
    },
    {
        id: 4,
        title: 'Taller de Expresión Oral y Oratoria',
        icon: '🎤',
        description: 'Aprende a hablar con elocuencia y persuasión para conmover, informar y deleitar.',
        fullDescription: `El Taller de Expresión Oral y Oratoria desarrolla habilidades comunicativas esenciales para el éxito académico y profesional.

Contenido del taller:
- Técnicas de oratoria y retórica
- Lenguaje corporal y gestual
- Manejo del miedo escénico
- Argumentación y debate
- Presentaciones efectivas
- Participación en concursos de oratoria

Los estudiantes aprenderán a expresarse con claridad, confianza y persuasión ante cualquier audiencia.`,
        benefits: [
            'Técnicas de oratoria',
            'Confianza al hablar en público',
            'Argumentación efectiva',
            'Presentaciones impactantes'
        ],
        schedule: 'Miércoles, 3:30 PM - 5:00 PM',
        instructor: 'Prof. Roberto Flores',
        level: 'Intermedio a Avanzado',
        image: null,
        imageAlt: 'Taller de Oratoria',
        color: 'secondary'
    },
    {
        id: 5,
        title: 'Cuaderno Viajero',
        icon: '📝',
        description: 'Fomenta la creatividad, la expresión escrita y las habilidades de observación.',
        fullDescription: `El Cuaderno Viajero es un proyecto creativo que estimula la escritura, la observación y la expresión personal.

Actividades:
- Escritura creativa y narrativa
- Diarios de viaje y experiencias
- Observación detallada del entorno
- Ilustraciones y collages
- Compartir historias con compañeros
- Publicación de trabajos destacados

Este taller permite a los estudiantes desarrollar su voz única como escritores mientras exploran diferentes géneros literarios.`,
        benefits: [
            'Escritura creativa',
            'Observación detallada',
            'Expresión personal',
            'Compartir experiencias'
        ],
        schedule: 'Viernes, 3:30 PM - 5:00 PM',
        instructor: 'Prof. Ana Mendoza',
        level: 'Todos los niveles',
        image: null,
        imageAlt: 'Cuaderno Viajero',
        color: 'primary'
    }
];

/**
 * Obtener taller por ID
 */
export const getWorkshopById = (id) => {
    return WORKSHOPS_DATA.find(workshop => workshop.id === id);
};
